import { render, staticRenderFns } from "./IconFileZip.vue?vue&type=template&id=53762c38&"
import script from "./IconFileZip.vue?vue&type=script&lang=js&"
export * from "./IconFileZip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports